var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 88,
    viewBox: "0 0 98 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "web_store_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "nsivykpiya",
    x: 0,
    y: 6,
    width: 98,
    height: 82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon base"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(9)",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#nsivykpiya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "shop-solid",
    d: "M4.6 24h70.8a4.6 4.6 0 0 0 3.825-7.15l-9.45-14.175A5.972 5.972 0 0 0 64.787 0H15.212a5.988 5.988 0 0 0-4.988 2.675L.775 16.837A4.665 4.665 0 0 0 0 19.387 4.607 4.607 0 0 0 4.6 24zM8 28v30a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V28h-8v20H16V28zm56 0v32a4 4 0 0 0 8 0V28z",
    transform: "translate(9 12)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebStoreIcon);
export default __webpack_public_path__ + "static/media/web_store_icon.380f1db54cbb59b65793581cde1aea49.svg";
export { ForwardRef as ReactComponent };